import Axios from 'axios'
import router from "@/router";

export default {
  GET_DATA_BLOG_PAGE (context, {categoryId = 0, limit, subCategory,carType} = data ) {
    context.commit('SET_DATA', {
      field: 'loading',
      data: true
    })
    Axios.get(`${context.state.api.admin}blog?category=${categoryId}&limit=${limit}${(subCategory?'&sub_cat='+subCategory:'')}${(carType?'&car_type='+carType:'')}`)
      .then((res) => {

        if (Array.isArray(res.data) ) {
          context.commit('SET_DATA', {
            field: 'blogPage.posts',
            data: res.data /* {
              filters: context.state.blogPage.filters,
              posts: res.data
            } */
          })
        }
        else {
          context.commit('SET_DATA', {
            field: 'blogPage.lastAddedPosts',
            data: res.data.lastAddedPosts /* {
              filters: context.state.blogPage.filters,
              posts: res.data.posts
            } */
          })
          context.commit('SET_DATA', {
            field: 'blogPage.posts',
            data: res.data.posts /* {
              filters: context.state.blogPage.filters,
              posts: res.data.posts
            } */
          })
        }
        
        context.commit('SET_DATA', {
          field: 'loading',
          data: false
        });

        document.dispatchEvent(new Event('renderer-ready'));
      })
      .catch((err) => console.log(err))
  },
  GET_DATA_POST (context, payload) {
    Axios.get(`${context.state.api.admin}blog/${payload}`)
      .then((res) => {
        context.commit('SET_DATA', {
          field: 'simplePage',
          data: res.data
        })


          document.dispatchEvent(new Event('renderer-ready'));
        return true
      })
      .catch((error) => {
          if (error.response.status === 404) {
              router.push('/not-found');
          }
      })
  },
  GET_SIMILAR_POSTS (context, payload) {
    const catId = `?category=${payload.categoryId}`
    const limit = `&limit=${payload.limit}`

    Axios.get(`${context.state.api.admin}blog${catId}${limit}`)
      .then((res) => {
        context.commit('SET_DATA', {
          field: 'similarPosts',
          data: res.data
        })
      })
      .catch((err) => console.log(err))
  }
} 
